import React from "react";
import nodeinstance from "../../../../nodeInstance";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import { useNavigate } from "react-router-dom";
import CreditNoteAmount from "./creditnotePopUp";
import { CgSpinner } from "react-icons/cg";

export default function InvoiceEdit({ invoiceNumber, cancel }) {
  const row = [
    {
      id: 1,
      name: "YTC",
    },
  ];

  const rowsData = [
    {
      id: 1,
      name: "YTC",
    },
  ];
  const dispatch = useDispatch();

  const tableHeading = [
    {
      rate_category_id: 1,
      title: "EMPLOYEE SALARY PACKAGE",
      bgPrimary: "bg-gray",
      bgSecondary: "bg-gray",
    },
  ];

  const totalTableHeading = [
    {
      title: "EMPLOYEE SALARY PACKAGE",
      bgPrimary: "bg-white", // Change background color to white
      bgSecondary: "bg-white", // Change background color to white
    },
  ];

  const tableProperties = {
    colWidth: "w-56",
    colHeight: "h-[2rem]",
    itemHeight: "h-[3rem]",
  };
  const tableProperties2 = {
    colWidth: "w-28",
    colHeight: "h-[2rem]",
    itemHeight: "h-[3rem]",
  };
  const dropDownData = [90, 180, 270, 360];
  const token = localStorage.getItem("nodeToken");
  //   const [employeeData, setEmployeeData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [updatedData, setUpdatedData] = useState([]);

  const [fees, setFees] = useState();

  const getfeeResponse = async () => {
    try {
      const feeData = await nodeinstance.get(
        "/dashboard/invoiceCostPlus/employeePackage",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (feeData.status === 200) {
        setFees(feeData?.data);
      }
    } catch (error) {
      console.log("error to be capctured here.", error);
    }
  };

  const response = async () => {
    // const reqObj = {
    //   invoice_no: invoiceNumber,
    // };
    try {
      const data = await nodeinstance.get(
        `/dashboard/invoiceCostPlus/getDetailsForEdit/${invoiceNumber}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (data.status === 200) {
        setEmployeeData(data?.data);
      }
    } catch (error) {
      console.log("error to be seen here..", error);
    }
  };
  useEffect(() => {
    response();
    getfeeResponse();
  }, [invoiceNumber]);
  console.log("fees to be printed here...", fees);
  const clientName = employeeData?.data?.[0]?.client;
  console.log("employeeData......employeeData", updatedData);
  const navigate = useNavigate();
  const [reveisedAmount, setReveisedAmount] = useState();
  const [diffAmount, setDiffAmount] = useState();
  const [tenure, setTenure] = useState();
  console.log("cancel.....cancel", cancel);
  const handleLocalTenure = (event, i) => {
    setTenure(event.target.value);
    const tenureInMilliseconds =
      parseInt(event.target.value) * 24 * 60 * 60 * 1000;

    setUpdatedData((previousData) => {
      const updatedData = employeeData.data.map((item, index) => {
        if (index === i) {
          const from_date = new Date(item.date);
          console.log("data to be seen here....", item);

          // Utility function to get cost by name
          const getFeeCost = (feeName) => {
            const feeItem = fees?.data?.find((fee) => fee.name === feeName);
            return feeItem ? parseFloat(feeItem.cost) : 0;
          };

          // Get the required fee costs
          const visa_fee = getFeeCost("VISA FEE");
          const Ajeer = getFeeCost("AJEER");
          const iqama_fee = getFeeCost("IQAMA FEE");
          const work_permit = getFeeCost("WORK PERMIT");
          const driving_license = getFeeCost("DRIVING LICENSE");
          const labor_card = getFeeCost("LABOR CARD");
          const insurance = getFeeCost("INSURANCE");
          const Baladiyah = getFeeCost("BALADIYAH");
          const Medical_for_iqama = getFeeCost("MEDICAL FOR IQAMA");
          const muqeem = getFeeCost("MUQEEM");
          const payroll_card = getFeeCost("PAYROLL CARD");
          const end_of_service = getFeeCost("END OF SERVICE");
          const vacation_salary = getFeeCost("VACATION SALARY");
          const vacation_ticket = getFeeCost("VACATION TICKET");

          const updatedItem = {
            ...item,
            tenure: event.target.value,
            till_date: new Date(from_date.getTime() + tenureInMilliseconds),
            visa_fee: (visa_fee / 360) * event.target.value,
            Ajeer: (Ajeer / 360) * event.target.value,
            iqama_fee: (iqama_fee / 360) * event.target.value,
            work_permit: (work_permit / 360) * event.target.value,
            driving_license: (driving_license / 360) * event.target.value,
            labor_card: (labor_card / 360) * event.target.value,
            insurance: (insurance / 360) * event.target.value,
            Baladiyah: (Baladiyah / 360) * event.target.value,
            Medical_for_iqama: (Medical_for_iqama / 360) * event.target.value,
            muqeem: (muqeem / 360) * event.target.value,
            payroll_card: (payroll_card / 360) * event.target.value,
            end_of_service: (end_of_service / 360) * event.target.value,
            vacation_salary: (vacation_salary / 360) * event.target.value,
            vacation_ticket: (vacation_ticket / 360) * event.target.value,
          };

          const data = {
            ...updatedItem,
            total:
              parseFloat(updatedItem.visa_fee || 0) +
              parseFloat(updatedItem.Ajeer || 0) +
              parseFloat(updatedItem.iqama_fee || 0) +
              parseFloat(updatedItem.work_permit || 0) +
              parseFloat(updatedItem.driving_license || 0) +
              parseFloat(updatedItem.labor_card || 0) +
              parseFloat(updatedItem.insurance || 0) +
              parseFloat(updatedItem.Baladiyah || 0) +
              parseFloat(updatedItem.Medical_for_iqama || 0) +
              parseFloat(updatedItem.muqeem || 0) +
              parseFloat(updatedItem.payroll_card || 0) +
              parseFloat(updatedItem.end_of_service || 0) +
              parseFloat(updatedItem.vacation_salary || 0) +
              parseFloat(updatedItem.vacation_ticket || 0),
          };

          return data;
        }
        return item;
      });
      return updatedData;
    });
  };

  const handleDataChange = (name, value, i) => {
    console.log("event.target.value...12345678....9999", name, value);
    setUpdatedData((previousData) => {
      const updatedData = previousData.map((item, index) => {
        if (index === i) {
          const updatedItem = {
            ...item,
            [name]: value,
            tenure: tenure ? tenure : item.tenure,
          };
          console.log("gyfgygygdfygydyfgyugyfdu", updatedItem);
          // Calculate total based on the updated values
          let total =
            parseFloat(updatedItem.Ajeer || 0) +
            parseFloat(updatedItem.visa_fee || 0) +
            parseFloat(updatedItem.iqama_fee || 0) +
            parseFloat(updatedItem.work_permit || 0) +
            parseFloat(updatedItem.driving_license || 0) +
            parseFloat(updatedItem.labor_card || 0) +
            parseFloat(updatedItem.insurance || 0) +
            parseFloat(updatedItem.Baladiyah || 0) +
            parseFloat(updatedItem.Medical_for_iqama || 0) +
            parseFloat(updatedItem.muqeem || 0) +
            parseFloat(updatedItem.payroll_card || 0) +
            parseFloat(updatedItem.end_of_service || 0) +
            parseFloat(updatedItem.vacation_salary || 0) +
            parseFloat(updatedItem.vacation_ticket || 0);
          return {
            ...updatedItem,
            total: total.toFixed(2), // Update total
          };
        }
        return item;
      });
      return updatedData;
    });
  };

  useEffect(() => {
    const datatopush = [];
    employeeData?.data?.map((data, i) => {
      const comObj = {
        ...data,
      };
      datatopush.push(comObj);
    });
    setUpdatedData(datatopush);
  }, [employeeData]);

  useEffect(() => {
    let Revised_amount = 0;
    updatedData?.forEach((data) => {
      Revised_amount += parseFloat(data.total);
    });
    console.log("Revised amount", Revised_amount);
    let diff = Revised_amount - employeeData?.data?.[0]?.total_amount;

    setReveisedAmount(Revised_amount);
    setDiffAmount(diff);
  }, [updatedData]);

  const [showPromptElement, setShowPromptElement] = useState(false);

  const onSubmit = async () => {
    if (reveisedAmount <= employeeData?.data?.[0]?.total_amount) {
      setShowPromptElement(true);
      // alert("Credit note amount to be displayed........");
      return;
    }
    try {
      const reqobj = {
        data: updatedData,
        invoice_amount: reveisedAmount,
      };
      const response = await nodeinstance.post(
        `/dashboard/invoiceCostPlus/generateInvoice`,
        reqobj,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: "Successfully uploaded.",
            color: "success",
          })
        );
        navigate("/dashboard/invoice-cost-plus");
      }
      console.log("invoice data........", reqobj);
    } catch (error) {
      console.log("error.....", error);
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };
  console.log("employeeData.....display data....", employeeData);

  const [downloading, setDowloading] = useState(false);

  const downloadFile = async () => {
    setDowloading(true);
    try {
      const response = await nodeinstance.get(
        `/dashboard/invoiceCostPlus/downloadEmploeesByInvoiceNumber/${invoiceNumber}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Employee List`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDowloading(false);
      }
    } catch (error) {
      setDowloading(false);
      console.log("error to be displayed here..", error);
      dispatch(
        setAppError({
          msg: "Failed to download employee Details",
        })
      );
    }
  };
  console.log("........updatedData........", updatedData);
  return (
    <>
      <div className="mt-4 mx-4 flex justify-between">
        <div className="text-left">
          <h2>
            CLIENT NAME:{" "}
            <strong>
              <span className="text-red">
                {" "}
                {employeeData?.data?.[0]?.client}{" "}
              </span>
            </strong>
          </h2>
          <h2>EMPLOYEES COUNT: {employeeData?.data?.length ?? 0}</h2>
          <h2>INVOICE NUMBER: {employeeData?.data?.[0]?.invoice_no}</h2>
        </div>
        <div className="text-center flex-grow">
          <h2>
            INVOICE AMOUNT (INC. VAT): {employeeData?.data?.[0]?.total_amount}
          </h2>
          <h2>
            REVISED AMOUNT (INC. VAT): {reveisedAmount ? reveisedAmount : 0}
          </h2>
          <h2>DIFFERENCE AMOUNT (INC. VAT):{diffAmount ? diffAmount : 0} </h2>
        </div>
        <div className="flex items-center justify-end">
          <input
            type="radio"
            name="creditnote"
            id="creditnote"
            checked={reveisedAmount <= employeeData?.data?.[0]?.total_amount}
            className="mr-2"
          />
          <label htmlFor="creditnote" className="mr-4">
            Add credit note
          </label>
          <input
            type="radio"
            name="newinvoice"
            id="newinvoice"
            checked={reveisedAmount > employeeData?.data?.[0]?.total_amount}
            className="mr-2"
          />
          <label htmlFor="newinvoice" className="mr-4">
            Generate new invoice{" "}
          </label>
          <button
            className="p-1 px-2 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2 h-10 p-3"
            onClick={() => downloadFile()}
            disabled={downloading}
          >
            <p>Download</p>
            {downloading && <CgSpinner className="animate-spin" />}
          </button>
        </div>
      </div>
      <div
        className="flex flex-col w-full gap-1 my-2 overflow-x-scroll pt-2 "
        style={rowsData?.data?.length > 4 ? { height: "250px" } : {}}
      >
        <div className="flex">
          {row.map((section, sectionIndex) => (
            <div className="flex flex-col relative" key={sectionIndex}>
              {sectionIndex == 0 && (
                <>
                  <div className={`flex w-full gap-1 `}>
                    <>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        S.NO.
                      </h3>
                      {/* <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        SELECT
                      </h3> */}

                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        EMP ID
                      </h3>

                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        EMP NAME
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        CLIENT
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        VISA PROVIDER
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        NATIONALITY
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        ACTUAL PROFESSION
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        VISA PROFESSION
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        PASSPORT NUMBER
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        IQAMA NUMBER
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        SEQUENCE
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        FROM DATE
                      </h3>

                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        TENURE
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        TILL DATE
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        INVOICE NUMBER
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        VISA FEE
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        IQAMA FEE
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        WORK PERMIT
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        DRIVING LICENSE
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        LABOR CARD
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        INSURANCE
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        BALADIYAH
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        AJEER
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        MEDICAL FOR IQAMA
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        MUQEEM
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        PAYROLL CARD
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        END OF SERVICE
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        VACATION SALARY
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        VACATION TICKET
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        TOTAL AMOUNT
                      </h3>
                    </>
                  </div>
                </>
              )}
              <div className="mb-2">
                {updatedData?.map((candidate, index) => (
                  <div
                    className="flex w-full gap-1 relative mb-2 mt-2"
                    key={index}
                  >
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {index + 1}
                    </p>

                    {/* <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      <input
                        // key={listItem.candidate_id}
                        type="checkbox"
                        // checked={selectedCandidates.includes(
                        //   listItem.candidate_id
                        // )}
                        // onChange={(event) =>
                        //   handleCheckboxChange(event, listItem.candidate_id)
                        // }
                      />
                    </p> */}

                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {candidate.candidate_id}
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {candidate.employee_name}
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {candidate.client}
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {candidate.visa_provider
                        ? candidate.visa_provider
                        : "N/A"}
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {candidate.nationality}
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {candidate.actual_profession}
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {candidate.visa_profession
                        ? candidate.visa_profession
                        : "N/A"}
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {candidate.passport_number}
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {candidate.iqama_number ? candidate.iqama_number : "N/A"}
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {candidate.sequence}
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {/* {candidate.date} */}
                      {new Date(candidate.date)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .split(" ")
                        .join("-")
                        .toUpperCase()}
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {/* {"YTC"} */}
                      <select
                        // className="border-[1px] border-border dark:bg-dark rounded-md h-10 p-1 mt-4 text-xs w-48"
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        onChange={(e) => {
                          handleLocalTenure(e, index);
                        }}
                        value={candidate.tenure}
                        disabled={candidate.Employee_Status === "INACTIVE"}
                      >
                        <option>{"SELECT TENURE"}</option>
                        {dropDownData.map((data, index) => (
                          <React.Fragment key={index}>
                            <option value={data}>{data}</option>
                          </React.Fragment>
                        ))}
                      </select>
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {new Date(candidate.till_date)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .split(" ")
                        .join("-")
                        .toUpperCase()}
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {candidate.invoice_no}
                    </p>

                    <input
                      type="number"
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                      value={candidate.visa_fee}
                      name="visa_fee"
                      onChange={(event) => {
                        handleDataChange(
                          event.target.name,
                          event.target.value,
                          index
                        );
                      }}
                    />
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {/* {candidate.iqama_fee} */}
                      <input
                        type="number"
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                        value={candidate.iqama_fee}
                        name="iqama_fee"
                        onChange={(event) => {
                          handleDataChange(
                            event.target.name,
                            event.target.value,
                            index
                          );
                        }}
                      />
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {/* {candidate.work_permit} */}
                      <input
                        type="number"
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                        value={candidate.work_permit}
                        name="work_permit"
                        onChange={(event) => {
                          handleDataChange(
                            event.target.name,
                            event.target.value,
                            index
                          );
                        }}
                      />
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {/* {candidate.driving_license} */}
                      <input
                        type="number"
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                        value={candidate.driving_license}
                        name="driving_license"
                        onChange={(event) => {
                          handleDataChange(
                            event.target.name,
                            event.target.value,
                            index
                          );
                        }}
                      />
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {/* {candidate.labor_card} */}
                      <input
                        type="number"
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                        value={candidate.labor_card}
                        name="labor_card"
                        onChange={(event) => {
                          handleDataChange(
                            event.target.name,
                            event.target.value,
                            index
                          );
                        }}
                      />
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {/* {candidate.insurance} */}
                      <input
                        type="number"
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                        value={candidate.insurance}
                        name="insurance"
                        onChange={(event) => {
                          handleDataChange(
                            event.target.name,
                            event.target.value,
                            index
                          );
                        }}
                      />
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {/* {candidate.Baladiyah} */}
                      <input
                        type="number"
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                        value={candidate.Baladiyah}
                        name="Baladiyah"
                        onChange={(event) => {
                          handleDataChange(
                            event.target.name,
                            event.target.value,
                            index
                          );
                        }}
                      />
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {/* {candidate.Ajeer} */}
                      <input
                        type="number"
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                        value={candidate.Ajeer}
                        name="Ajeer"
                        onChange={(event) => {
                          handleDataChange(
                            event.target.name,
                            event.target.value,
                            index
                          );
                        }}
                      />
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {/* {candidate.Medical_for_iqama} */}
                      <input
                        type="number"
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                        value={candidate.Medical_for_iqama}
                        name="Medical_for_iqama"
                        onChange={(event) => {
                          handleDataChange(
                            event.target.name,
                            event.target.value,
                            index
                          );
                        }}
                      />
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {/* {candidate.muqeem} */}
                      <input
                        type="number"
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                        value={candidate.muqeem}
                        name="muqeem"
                        onChange={(event) => {
                          handleDataChange(
                            event.target.name,
                            event.target.value,
                            index
                          );
                        }}
                      />
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {/* {candidate.payroll_card} */}
                      <input
                        type="number"
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                        value={candidate.payroll_card}
                        name="payroll_card"
                        onChange={(event) => {
                          handleDataChange(
                            event.target.name,
                            event.target.value,
                            index
                          );
                        }}
                      />
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {/* {candidate.end_of_service} */}
                      <input
                        type="number"
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                        value={candidate.end_of_service}
                        name="end_of_service"
                        onChange={(event) => {
                          handleDataChange(
                            event.target.name,
                            event.target.value,
                            index
                          );
                        }}
                      />
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {/* {candidate.vacation_salary} */}
                      <input
                        type="number"
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                        value={candidate.vacation_salary}
                        name="vacation_salary"
                        onChange={(event) => {
                          handleDataChange(
                            event.target.name,
                            event.target.value,
                            index
                          );
                        }}
                      />
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {/* {candidate.vacation_ticket} */}
                      <input
                        type="number"
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                        value={candidate.vacation_ticket}
                        name="vacation_ticket"
                        onChange={(event) => {
                          handleDataChange(
                            event.target.name,
                            event.target.value,
                            index
                          );
                        }}
                      />
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {/* {candidate.total_amount} */}
                      <input
                        type="number"
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                        value={candidate.total}
                      />
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "30px",
        }}
        // className="p-1 bg-red text-white rounded-md max-w-sm m-3 my-2 flex gap-1 ml-30 justify-center items-center"
      >
        {/* <button
          style={{
            padding: "8px 20px",
            fontSize: "16px",
            backgroundColor: "black",
            color: "white",
            border: "none",
            marginRight: "20px",
            borderRadius: "5px",
          }}
          //   onClick={() => {
          //     GenerateInvoice();
          //   }}
        >
          EDIT
        </button> */}
        <button
          style={{
            padding: "8px 20px",
            fontSize: "16px",
            backgroundColor: "red",
            color: "white",
            border: "none",
            borderRadius: "5px",
          }}
          onClick={() => {
            onSubmit();
          }}
          disabled={cancel === "CANCELLED"}
        >
          SUBMIT
        </button>
        {showPromptElement ? (
          <CreditNoteAmount
            showPromptElement={showPromptElement}
            setShowPromptElement={setShowPromptElement}
            propData={employeeData}
            differenceAmount={diffAmount}
            data={updatedData}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
}
